import React from 'react';
import { useIntl } from 'react-intl';
import { IconSuccess } from '@americanexpress/dls-icons';
import styles from './AssertionSuccess.scss';

const AssertionSuccess = () => {
  const intl = useIntl();

  return (
    <div className={styles['passkey-assertion__loading']}>
      <h2 className={styles['passkey-assertion__verifying-title']}>
        <IconSuccess
          className="verify-icon"
          size="md"
          isFilled={true}
          color="brand"
          title="Verified"
        />
        {intl.formatMessage({ id: 'passkeyAssertion.verifiedTitle' })}
      </h2>
      <p className={styles['passkey-assertion__description']}>
        {intl.formatMessage({ id: 'passkeyAssertion.verifiedMessage' })}
      </p>
      <p className={styles['passkey-assertion__verifying-status']}>
        {intl.formatMessage({ id: 'passkeyAssertion.redirect' })}
      </p>
    </div>
  );
};

export default AssertionSuccess;
